import React, { Component } from 'react';

class Blog extends Component {
    state = {
        blogData: [],
        loading: true,
        page: 1,
        hasMore: true,
        loadingMore: false
    }

    fetchBlogs(page) {
        fetch(`${process.env.REACT_APP_CMS_URL}/wp-json/wp/v2/posts?_embed&per_page=10&page=${page}`)
            .then(res => {
                // Check if more pages exist
                const totalPages = res.headers.get('X-WP-TotalPages');
                if (page >= totalPages) {
                    this.setState({ hasMore: false });
                }
                return res.json();
            })
            .then(data => {
                this.setState(prevState => ({
                    blogData: [...prevState.blogData, ...data],
                    loading: false,
                    loadingMore: false
                }));
            })
            .catch(err => {
                console.error(err);
                this.setState({ loading: false, loadingMore: false });
            });
    }

    componentDidMount() {
        this.fetchBlogs(1);
    }

    loadMore = () => {
        const nextPage = this.state.page + 1;
        this.setState({ page: nextPage, loadingMore: true });
        this.fetchBlogs(nextPage);
    }

    render() {
        if (this.state.loading) {
            return <div>Loading blogs...</div>;
        }

        return (
            <div>
                <div className="row">
                    {this.state.blogData.map((item, idx) => {
                        return(
                            <div key={`bt_${idx}`} className="col-12 col-md-6">
                                <div className="single-blog res-margin">
                                    <div className="blog-thumb">
                                        <a href={`/blog/${item.slug}`}>
                                            <img 
                                                src={item._embedded?.['wp:featuredmedia']?.[0]?.source_url || "https://cms.moneymonkapp.in/wp-content/uploads/2026/04/Untitled-video_000.jpg"} 
                                                alt={item.title.rendered} 
                                            />
                                        </a>
                                    </div>
                                    <div className="blog-content p-4">
                                        <ul className="meta-info d-flex justify-content-between">
                                            <li>By <a className="text-primary" href="/#">{item._embedded?.author?.[0]?.name}</a></li>
                                            <li><a href="/#">{new Date(item.date).toLocaleDateString()}</a></li>
                                        </ul>
                                        <h3 className="blog-title my-3">
                                            <a href={`/blog/${item.slug}`}>{item.title.rendered}</a>
                                        </h3>
                                        <div dangerouslySetInnerHTML={{__html: item.excerpt.rendered}} />
                                        <a href={`/blog/${item.slug}`} className="blog-btn mt-3">Read More</a>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Load More Button */}
                {this.state.hasMore && (
                    <div className="row">
                        <div className="col-12 text-center mt-4">
                            <button 
                                className="btn btn-bordered"
                                onClick={this.loadMore}
                                disabled={this.state.loadingMore}
                            >
                                {this.state.loadingMore ? 'Loading...' : 'Load More Blogs'}
                            </button>
                        </div>
                    </div>
                )}

                {/* No more blogs message */}
                {!this.state.hasMore && this.state.blogData.length > 10 && (
                    <div className="row">
                        <div className="col-12 text-center mt-4">
                            <p>You've seen all blogs! ✅</p>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Blog;